"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactSelect = require("react-select");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var OptionWrapper = function OptionWrapper(props) {
  var _option$style, _option$className;

  var className = props.className,
      innerProps = props.innerProps,
      option = props.data;

  var _key = option.key ? option.key.toString() : '';

  var _style = ((_option$style = option.style) === null || _option$style === void 0 ? void 0 : _option$style.option) || option.style;

  var _innerProps = _objectSpread(_objectSpread({}, innerProps), {}, {
    style: _style
  });

  var _className = (0, _classnames2.default)(className, ((_option$className = option.className) === null || _option$className === void 0 ? void 0 : _option$className.option) || option.className, (0, _defineProperty2.default)({}, "Select__option--".concat(_key), !!_key));

  return React.createElement(_reactSelect.components.Option, Object.assign({}, props, {
    innerProps: _innerProps,
    className: _className
  }));
};

var _default = OptionWrapper;
exports.default = _default;